// extracted by mini-css-extract-plugin
module.exports = {"carouselPrevArrow":"index-module--carouselPrevArrow--TlsKW","carouselNextArrow":"index-module--carouselNextArrow--2YruW"};